import React from "react";
import { Lamp, Sofa } from "lucide-react";

export const SimpleProductIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-24 h-24 bg-slate-100 rounded-md">
      <Lamp size={64} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const ConfigurableProductIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-24 h-24 bg-indigo-100 rounded-md">
      <Sofa size={64} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};
